module.exports = __webpack_public_path__ + "img/three3Green.1ab54a45.jpg";